export default __webpack_public_path__ + "static/media/datawhite.0dd8ee80.png";